<template>
  <b-card>
    <FormView
      :data="$store.getters['categoryV2/detailData']"
      :fields="$store.getters['categoryV2/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/v2/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('categoryV2/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
